import moment from 'moment';

const config = function($stateProvider, $urlRouterProvider, AppConfigurationProvider) {
    const acp = AppConfigurationProvider;

    moment.locale('hr');

    $urlRouterProvider.otherwise('/dashboard');

    let app = acp.application('DentalLab');

    app.addEntity(acp.entity('dashboard'));
    app.addEntity(acp.entity('Tehnicar').label('Tehničar'));
    app.addEntity(acp.entity('Valuta').label('Valuta'));
    app.addEntity(acp.entity('PoreznaStopa').label('Porezna stopa'));
    app.addEntity(acp.entity('ProtetskiRad').label('Protetski rad'));
    app.addEntity(acp.entity('Cjenik').label('Cjenik'));
    app.addEntity(acp.entity('StavkaCjenika').label('Stavka cjenika'));
    app.addEntity(acp.entity('Ordinacija').label('Ordinacija'));
    app.addEntity(acp.entity('RadniNalog').label('Radni nalog'));
    app.addEntity(acp.entity('StavkaNaloga').label('Stavka naloga'));
    app.addEntity(acp.entity('Boja').label('Boja'));
    app.addEntity(acp.entity('OznakaBoje').label('Oznaka boje'));
    app.addEntity(acp.entity('FazaNaloga').label('Faza naloga'));
    app.addEntity(acp.entity('KorisnikOrdinacija').label('Korisnici'));
    app.addEntity(acp.entity('Materijal').label('Materijal'));
    app.addEntity(acp.entity('VrstaRada').label('Vrsta rada'));
    app.addEntity(acp.entity('GrupaRada').label('Grupa rada'));
    app.addEntity(acp.entity('Komentar').label('Komentar'));

    acp.configure(app);

    require('./components/dashboard/config.js')(acp, app);
    require('./components/tehnicar/config.js')(acp, app);
    require('./components/valuta/config.js')(acp, app);
    require('./components/poreznaStopa/config.js')(acp, app);
    require('./components/protetskiRad/config.js')(acp, app);
    require('./components/cjenik/config.js')(acp, app);
    require('./components/ordinacija/config.js')(acp, app);
    require('./components/radniNalog/config.js')(acp, app);
    require('./components/stavkaNaloga/config.js')(acp, app);
    require('./components/boja/config.js')(acp, app);
    require('./components/oznakaBoje/config.js')(acp, app);
    require('./components/fazaNaloga/config.js')(acp, app);
    require('./components/korisnikOrdinacija/config.js')(acp, app);
    require('./components/materijal/config.js')(acp, app);
    require('./components/vrstaRada/config.js')(acp, app);
    require('./components/grupaRada/config.js')(acp, app);
    require('./components/komentar/config.js')(acp, app);

    require('./components/auth/states.js')($stateProvider);
    require('./components/dashboard/states.js')($stateProvider);
    require('./components/ordinacija/states.js')($stateProvider);
    require('./components/cjenik/states.js')($stateProvider);
    require('./components/common/crud/states.js')($stateProvider);
    require('./components/radniNalog/states.js')($stateProvider);
};

const run = function($rootScope, $state, djangoAuth, AppConfiguration, $transitions) {
    djangoAuth.initialize('/rest-auth', true);

    var match = {
        to: function(state) {
            // return state.data != null && state.data.authRequired === true;
            return state.name !== 'login';
        }
    };

    $transitions.onStart(match, function(trans) {
        djangoAuth
            .authenticationStatus(true)
            .then(function() {
                return djangoAuth.profile();
            })
            .then(function(response) {
                $rootScope.user = response;
            })
            .catch(function() {
                return $state.go('login');
            });
        return true;
    });

    // $rootScope.$state = $state;

    let app = AppConfiguration();
    app.menu(require('./menu.js')(AppConfiguration, $state));
};

run.$inject = ['$rootScope', '$state', 'djangoAuth', 'AppConfiguration', '$transitions'];
config.$inject = ['$stateProvider', '$urlRouterProvider', 'AppConfigurationProvider'];

export { config };
export { run };



// WEBPACK FOOTER //
// ./app/config.js